import sessionStorage from "core/services/storageService/sessionStorage";

const setAuthData = authData => sessionStorage.set("authorizationData", authData)

export default setAuthData;